module.exports = __webpack_public_path__ + "static/media/Chair_Arm_Before.8e67c84f.jpg";